import { type ComponentProps, type FunctionComponent } from 'react'
import { SvgIcon, type SvgIconProps } from '../SvgIcon/SvgIcon'

export type SvgComponent = FunctionComponent<ComponentProps<'svg'> & { title?: string }>

export const createSvgIcon = (Component: SvgComponent) => {
  return function CreateSvgIcon(props: Omit<SvgIconProps, 'children'>) {
    return (
      <SvgIcon {...props}>
        <div>
          <Component />
        </div>
      </SvgIcon>
    )
  }
}
